





































import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF } from '@/interfaces';

interface NewInspectionsRec {
  planned_date: string|null;
  due_date: string|null;
  remarks: string|null;
  inspector1_id: number|null;
  inspector2_id: number|null;
  inspector3_id: number|null;
  responsible_id: number|null;
}

@Component
export default class SiteReportsOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public showNewInspections = false;
  public dialogNewInspections = false;

  public recNewInspections: NewInspectionsRec = {planned_date: null, due_date: null, remarks: null, inspector1_id: null, inspector2_id: null, inspector3_id: null, responsible_id: null};

  public handleTableLoaded(overview) {
    // console.log(check_bool(overview.filters.not_sent_accounting) , (overview.filters.customer_id > 0) , (overview.tableTotal > 0));
  }
  public handleItemSelected(overview, event) {
    // console.log('handleItemSelected', event, overview.multiSelect, overview.countSelections(), overview.countSelections() + (event.value ? 1 : -1));
    this.changeSelection(overview, overview.countSelections() + (event.value ? 1 : -1));
  }
  public handleToggleSelectAll(overview, event) {
    // console.log('handleToggleSelectAll', event, overview.multiSelect, overview.countSelections(), event.value ? event.items.length : 0);
    this.changeSelection(overview, event.value ? event.items.length : 0);
  }
  public handleChangeMultiSelect(overview, event) {
    // console.log('handleChangeMultiSelect', event, overview.multiSelect, overview.countSelections());
    this.changeSelection(overview, event.value ? overview.countSelections() : 0);
  }
  public changeSelection(overview, count) {
    // console.log('changeSelection', count);
    this.showNewInspections = count > 0;
  }
  public async refreshDMIData() {
    if (this.$refs.overview) {
      const overview = (this.$refs.overview as unknown) as OverviewLayoutITF;
      console.log(overview);
      overview.loading = true;
      await this.api.postAction(this.$store, this.apiUrl + 'refreshbmidata');
      ((this.$refs.overview as unknown) as OverviewLayoutITF).tableUpdateData(true);
    }
  }
  public startNewInspections() {
    // const overview: any = this.$refs.overview;
    // this.recNewInspections.bank_date = new_curdate();
    this.dialogNewInspections = true;
  }
  public async executeNewInspections(rec) {
    this.dialogNewInspections = false;
    const overview: any = this.$refs.overview;
    rec.idlist = overview.getSelectedIds();
    const response = await this.api.postAction(this.$store, this.apiUrl + 'create_inspections', rec);
    overview.tableUpdateData(true);
  }
  public checkInspectors(rec) {
    // console.log('checkInspectors >', rec.inspector1_id, rec.inspector2_id, rec.inspector3_id);
    const i1 = rec.inspector1_id;
    let i2 = rec.inspector2_id;
    let i3 = rec.inspector3_id;
    if (i3 && ((i3 === i2) || (i3 === i1))) {
      i3 = null;
      this.$set(rec, 'inspector3_id', i3);
    }
    if (i2 && i2 === i1) {
      if (i3) {
        i2 = i3;
        i3 = null;
        this.$set(rec, 'inspector2_id', i2);
        this.$set(rec, 'inspector3_id', i3);
      } else {
        i2 = null;
        this.$set(rec, 'inspector2_id', i2);
      }
    }
    // console.log('checkInspectors <>', rec.inspector1_id, rec.inspector2_id, rec.inspector3_id);
  }
}
